<template>
  <div class="container">
    <img src="../../assets/fangyi/chanpintopimg.png" alt="" />
    <div class="content">
      <div class="item" v-for="(item, index) in productInfoList" :key="index">
        <div class="left">
          <!-- <img :src="baseUrl + item.imageUrl" alt="" /> -->
          <img src="../../assets/imgs/apply/success_icon.png" alt="" />
          <div>
            <h2>{{item.name}}</h2>
            <span>{{item.describe}}</span>
          </div>
        </div>
        <div class="right">
         <el-button type="primary">查看详情</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as indexApi from "@/api/index";
import baseUrl from "../../api/baseUrl";
export default {
  data() {
    return {
      productInfoList: [],
    };
  },
  created() {
    this.productInfo();
  },
  methods: {
    productInfo() {
      indexApi.productInfoList().then((res) => {
        res = this.paramDecrypt(res);
        console.log(res);
        if (res.code == 200) {
          this.productInfoList = res.data;
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.container {
  background-color: #fff;
  .content {
    width: 60%;
    margin: 0 auto;
    padding: 30px 0;
    .item {
      width: 100%;
      // height: 50px;
      border: 1px solid #d3d5dc;
      padding: 15px 50px;
      padding-right: 10px;
      border-radius: 6px;
      display: flex;
      margin: 20px 0;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 35px;
        }
        div {
          margin-left: 20px;
          h2 {
            margin: 0;
            color: #00479f;
          }
          span {
            color: #2a2a2a;
          }
        }
      }
      // .right {
      // }
    }
  }
}
</style>